import { render } from "./vendors.vue?vue&type=template&id=f0b78508&scoped=true"
import script from "./vendors.vue?vue&type=script&lang=js"
export * from "./vendors.vue?vue&type=script&lang=js"

import "./vendors.vue?vue&type=style&index=0&id=f0b78508&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b78508"]])

export default __exports__